<div class="oase-lieferschein">
	<mat-card appearance="outlined">
		<mat-card-title>
			{{ OBJ_LNG_NAME+'.liste' | translate:locale.language }} <span *ngIf="dataSource" class="anzahl"> ({{ 'allgemein.daten.insgesamt' | translate:locale.language:{ count: dataSource.page.totalElements } }})</span>
			<p class="errors" *ngIf="dataService.fehler" [innerHTML]="dataService.fehler.messagehtml"></p>
			<p class="errors" *ngIf="fehlerMain" [innerHTML]="fehlerMain.messagehtml"></p>
		</mat-card-title>

		<mat-card-content>

			<div class="tabelle">
				<div class="tabelle-kopf" [style.display]="">
					<mat-form-field>
						<input matInput #filter>
						<mat-label>
							<i class="material-icons app-input-icon">search</i> {{ 'allgemein.suche' | translate:locale.language }}
						</mat-label>
						<button matSuffix mat-icon-button class="suche" (click)="clearFilter()" matTooltip="{{ 'allgemein.klick.leeresuche' | translate:locale.language }}"
								[disabled]="dataSource.isWaitingForResponse || filter.value == ''"><mat-icon>close</mat-icon></button>
					</mat-form-field>
				</div>

				<!-- Wenn eine Auswahl nicht benötigt wird einfach in displayedColumns die Spalte select nicht einbinden -->

				<div class="ladedaten" *ngIf="dataSource.isWaitingForResponse">
					<div>{{ 'allgemein.daten.laden.start' | translate:locale.language }} <mat-icon>free_breakfast</mat-icon></div>
					<div><mat-spinner color="primary"></mat-spinner></div>
					<div>{{ 'allgemein.daten.laden.ende' | translate:locale.language }}</div>
				</div>

				<mat-table #table [dataSource]="dataSource" matSort [style.display]="onDesktop()">

					<ng-container matColumnDef="belegnummerSortierbar">
						<mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="22">{{ OBJ_LNG_NAME+'.belegnummer' | translate:locale.language }}</mat-header-cell>
						<mat-cell fxFlex="22" *matCellDef="let row">

							{{ row.belegnummer }}

						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="datumSortierbar">
						<mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="12">{{ OBJ_LNG_NAME+'.datum' | translate:locale.language }}</mat-header-cell>
						<mat-cell fxFlex="12" *matCellDef="let row">

							{{ row.datum }}

						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="aufLieferschein">
						<mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="12">{{ OBJ_LNG_NAME+'.aufLieferschein' | translate:locale.language }}</mat-header-cell>
						<mat-cell class="right" fxFlex="12" *matCellDef="let row">

							{{ row.aufLieferschein | number: '1.2' }} €

						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="hinweis">
						<mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="31">{{ OBJ_LNG_NAME+'.hinweis' | translate:locale.language }}</mat-header-cell>
						<mat-cell fxFlex="31" *matCellDef="let row">

							{{ row.hinweis }}

						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="download">
						<mat-header-cell *matHeaderCellDef fxFlex="23">{{ 'allgemein.download' | translate:locale.language }}</mat-header-cell>
						<mat-cell fxFlex="23" *matCellDef="let row">

							<a mat-raised-button *ngIf="row.positionen !== '0'" (click)="download(row)" [color]="row.heruntergeladen ? null : 'accent'"><mat-icon>file_download</mat-icon></a>
							<!--							<a mat-raised-button [href]="getDownloadLink(row)" (click)="markiereAlsHeruntergeladen(row)" target="_blank" [color]="row.heruntergeladen ? null : 'accent'"><mat-icon>file_download</mat-icon></a>-->
							<!--                <a *ngIf="lieferschein.positionen !== '0'" mat-raised-button [href]="authService.getAuthUrl(REST_API_BASE+lieferschein.positionen)" (click)="markiereAlsHeruntergeladen(lieferschein)" target="_blank" [color]="lieferschein.heruntergeladen ? null : 'accent'"><mat-icon>file_download</mat-icon></a>-->
							<span *ngIf="row.positionen === '0'">{{ OBJ_LNG_NAME+'.keineDatei' | translate:locale.language }}</span>

						</mat-cell>
					</ng-container>


					<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
					<mat-row *matRowDef="let row; columns: displayedColumns; let i = index;" ></mat-row>

				</mat-table>

				<div class="sucheleer" [style.display]="dataSource.page.totalElements > 0 && dataSource.page.searchElements == 0 ? '' : 'none'">
					{{ 'allgemein.daten.sucheleer' | translate:locale.language }}
				</div>

				<div class="keinedaten" [style.display]="dataSource.page.totalElements == 0 ? '' : 'none'">
					{{ 'allgemein.daten.keine' | translate:locale.language }}
				</div>

				<mat-paginator #paginator
							   [length]="dataSource.page.searchElements"
							   [pageIndex]="0"
							   [pageSize]="10"
							   [pageSizeOptions]="[5,10,15,20,25,30,50,100,200,500]">
				</mat-paginator>
				<!--				<mat-paginator #paginator [class.hide]="dataSource.page.searchElements <= dataSource.page.size"-->
				<!--							   [length]="dataSource.page.searchElements"-->
				<!--							   [pageIndex]="0"-->
				<!--							   [pageSize]="10"-->
				<!--							   [pageSizeOptions]="[5,10,15,20,25,30,50,100,200,500]">-->
				<!--				</mat-paginator>-->
			</div>
		</mat-card-content>
	</mat-card>

	<div [style.display]="onMobile()" class="mobile">
		<mat-card appearance="outlined" *ngFor="let lieferschein of dataSource.content">
			<mat-card-title>
				{{ OBJ_LNG_NAME+'.belegnummer' | translate:locale.language }} : {{ lieferschein.belegnummer }}
			</mat-card-title>
			<mat-card-subtitle>
				{{ OBJ_LNG_NAME+'.datum' | translate:locale.language }} : {{ lieferschein.datum }}
			</mat-card-subtitle>
			<mat-card-content>
				{{ OBJ_LNG_NAME+'.aufLieferschein' | translate:locale.language }} : {{ lieferschein.aufLieferschein | number: '1.2' }} €
			</mat-card-content>
			<mat-card-content>
				{{ OBJ_LNG_NAME+'.hinweis' | translate:locale.language }} : {{ lieferschein.hinweis }}
			</mat-card-content>
			<mat-card-actions align="end">
				<a mat-raised-button *ngIf="lieferschein.positionen !== '0'" (click)="download(lieferschein)" [color]="lieferschein.heruntergeladen ? null : 'accent'"><mat-icon>file_download</mat-icon></a>
				<span *ngIf="lieferschein.positionen === '0'">{{ OBJ_LNG_NAME+'.keineDatei' | translate:locale.language }}</span>
			</mat-card-actions>
		</mat-card>
	</div>

</div>


<!--<div class="oase-lieferschein">-->
<!--    <mat-card *ngIf="media.isActive('gt-sm')">-->
<!--        <mat-card-title>-->
<!--            {{ OBJ_LNG_NAME+'.liste' | translate:locale.language }}<span *ngIf="data" class="anzahl"> ({{ 'allgemein.daten.insgesamt' | translate:locale.language:{ count: data.length } }})</span>-->
<!--            <p class="errors" *ngIf="fehlerMain" [innerHTML]="fehlerMain.messagehtml"></p>-->
<!--        </mat-card-title>-->
<!--        <mat-card-content>-->
<!--            <table class="table table-striped" [md2Data]="data | dataPipeLieferschein:search" #md2="md2DataTable" [rowsPerPage]="12" [sortBy]="datumSortierbar">-->
<!--                <thead>-->
<!--                    <tr *ngIf="!ladedaten && (md2.data.length > 0 || search != '')">-->
<!--                        <td colspan="5" class="suche">-->
<!--                            <mat-form-field class="full-width tabellesuche">-->
<!--                                <input matInput class="md2-input" [(ngModel)]="search" />-->
<!--                                <mat-placeholder>-->
<!--                                    <i class="material-icons app-input-icon">search</i> {{ 'allgemein.suche' | translate:locale.language }}-->
<!--                                </mat-placeholder>-->
<!--                            </mat-form-field>-->
<!--                            <button mat-icon-button class="tabellesuchebtn" (click)="search=''" matTooltip="{{ 'allgemein.klick.leeresuche' | translate:locale.language }}" [disabled]="ladedaten || dialogrunningajaxcall || search == ''"><mat-icon>close</mat-icon></button>-->
<!--                        </td>-->
<!--                    </tr>-->
<!--                    <tr>-->
<!--                        <th class="center" md2SortBy="belegnummerSortierbar">{{ OBJ_LNG_NAME+'.belegnummer' | translate:locale.language }}</th>-->
<!--                        <th class="center" md2SortBy="datumSortierbar">{{ OBJ_LNG_NAME+'.datum' | translate:locale.language }}</th>-->
<!--                        <th class="center" md2SortBy="aufLieferschein">{{ OBJ_LNG_NAME+'.aufLieferschein' | translate:locale.language }}</th>-->
<!--                        <th class="center" md2SortBy="hinweis">{{ OBJ_LNG_NAME+'.hinweis' | translate:locale.language }}</th>-->
<!--                        <th class="center">{{ 'allgemein.download' | translate:locale.language }}</th>-->
<!--                    </tr>-->
<!--                </thead>-->
<!--                <tbody>-->
<!--                    <tr *ngIf="ladedaten" class="ladedaten">-->
<!--                        <td colspan="5" class="center">-->
<!--                            {{ 'allgemein.daten.laden.start' | translate:locale.language }}-->
<!--                            <mat-icon>hourglass_empty</mat-icon>-->
<!--                            <mat-spinner color="accent"></mat-spinner>-->
<!--                            {{ 'allgemein.daten.laden.ende' | translate:locale.language }}-->
<!--                        </td>-->
<!--                    </tr>-->
<!--                    <tr *ngIf="!ladedaten && md2.data.length == 0" class="keinedaten">-->
<!--                        <td colspan="5" class="center">{{ (search == '' ? 'allgemein.daten.keine' : 'allgemein.daten.sucheleer')  | translate:locale.language }}</td>-->
<!--                    </tr>-->
<!--                    <tr *ngFor="let lieferschein of md2.data">-->
<!--                        <td class="center">{{ lieferschein.belegnummer }}</td>-->
<!--                        <td class="center">{{ lieferschein.datum }}</td>-->
<!--                        <td class="right">{{ lieferschein.aufLieferschein | number: '1.2' }} €</td>-->
<!--                        <td class="center">{{ lieferschein.hinweis }}</td>-->
<!--                        <td class="center">-->
<!--                          <a mat-raised-button *ngIf="lieferschein.positionen !== '0'" [href]="authService.getAuthUrl(REST_API_BASE+lieferschein.positionen)" (click)="markiereAlsHeruntergeladen(lieferschein)" target="_blank" [color]="lieferschein.heruntergeladen ? null : 'accent'"><mat-icon>file_download</mat-icon></a>-->
<!--                          <span *ngIf="lieferschein.positionen === '0'">{{ OBJ_LNG_NAME+'.keineDatei' | translate:locale.language }}</span>-->
<!--                        </td>-->
<!--                      </tr>-->
<!--                </tbody>-->
<!--                <tfoot>-->
<!--                    <tr>-->
<!--                        <td colspan="5">-->
<!--                            <md2-pagination [rowsPerPageSet]="[5,10,12,15,20,25,30,50,100,200,500]"></md2-pagination>-->
<!--                        </td>-->
<!--                    </tr>-->
<!--                </tfoot>-->
<!--            </table>-->
<!--        </mat-card-content>-->
<!--    </mat-card>-->
<!--    <mat-card *ngIf="!media.isActive('gt-sm')">-->
<!--        <mat-card-title>-->
<!--            {{ OBJ_LNG_NAME+'.liste' | translate:locale.language }}<span *ngIf="data" class="anzahl"> ({{ 'allgemein.daten.insgesamt' | translate:locale.language:{ count: data.length } }})</span>-->
<!--            <p class="errors" *ngIf="fehlerMain" [innerHTML]="fehlerMain.messagehtml"></p>-->
<!--        </mat-card-title>-->
<!--        <mat-card-subtitle *ngIf="!ladedaten && data.length == 0">-->
<!--            {{ (search == '' ? 'allgemein.daten.keine' : 'allgemein.daten.sucheleer')  | translate:locale.language }}-->
<!--        </mat-card-subtitle>-->
<!--        <mat-card-content *ngIf="ladedaten">-->
<!--            {{ 'allgemein.daten.laden.start' | translate:locale.language }}-->
<!--            <mat-icon>hourglass_empty</mat-icon>-->
<!--            <mat-spinner color="accent"></mat-spinner>-->
<!--            {{ 'allgemein.daten.laden.ende' | translate:locale.language }}-->
<!--        </mat-card-content>-->
<!--        <mat-card-content *ngIf="!ladedaten && (data.length > 0 || search != '')">-->
<!--            <mat-form-field class="full-width tabellesuche">-->
<!--                <input matInput class="md2-input" [(ngModel)]="search" />-->
<!--                <mat-placeholder>-->
<!--                    <i class="material-icons app-input-icon">search</i> {{ 'allgemein.suche' | translate:locale.language }}-->
<!--                </mat-placeholder>-->
<!--            </mat-form-field>-->
<!--            <button mat-icon-button class="tabellesuchebtn" (click)="search=''" matTooltip="{{ 'allgemein.klick.leeresuche' | translate:locale.language }}" [disabled]="ladedaten || dialogrunningajaxcall || search == ''"><mat-icon>close</mat-icon></button>-->
<!--        </mat-card-content>-->
<!--    </mat-card>-->
<!--    <ng-container *ngIf="!media.isActive('gt-sm')">-->
<!--        <mat-card *ngFor="let lieferschein of data | dataPipeLieferschein:search">-->
<!--            <mat-card-title>-->
<!--                {{ OBJ_LNG_NAME+'.belegnummer' | translate:locale.language }} : {{ lieferschein.belegnummer }}-->
<!--            </mat-card-title>-->
<!--            <mat-card-subtitle>-->
<!--                {{ OBJ_LNG_NAME+'.datum' | translate:locale.language }} : {{ lieferschein.datum }}-->
<!--            </mat-card-subtitle>-->
<!--            <mat-card-content>-->
<!--                {{ OBJ_LNG_NAME+'.aufLieferschein' | translate:locale.language }} : {{ lieferschein.aufLieferschein | number: '1.2' }} €-->
<!--            </mat-card-content>-->
<!--            <mat-card-content>-->
<!--                {{ OBJ_LNG_NAME+'.hinweis' | translate:locale.language }} : {{ lieferschein.hinweis }}-->
<!--            </mat-card-content>-->
<!--            <mat-card-actions align="end">-->
<!--                <a *ngIf="lieferschein.positionen !== '0'" mat-raised-button [href]="authService.getAuthUrl(REST_API_BASE+lieferschein.positionen)" (click)="markiereAlsHeruntergeladen(lieferschein)" target="_blank" [color]="lieferschein.heruntergeladen ? null : 'accent'"><mat-icon>file_download</mat-icon></a>-->
<!--                <span *ngIf="lieferschein.positionen === '0'">{{ OBJ_LNG_NAME+'.keineDatei' | translate:locale.language }}</span>-->
<!--            </mat-card-actions>-->
<!--        </mat-card>-->
<!--    </ng-container>-->
<!--</div>-->
